<template>
    <div v-if="routes && routeTypes" class="transportation-options">
        <div class="form-group row">
            <div v-for="routeType in routeTypes" class="d-inline-block ml-3">
                <radio name="deal-type" :checked="(routeType.id === selectedRouteType.id)" :value="routeType.id + ''" @input="changeRouteType">
                    {{ routeType.description }}
                </radio>
            </div>
        </div>

        <!-- Type 1: pick-up -->
        <!-- Type 2: drop-off -->
        <!-- Type 3: round trip -->

        <div v-if="isSingleTrip">
            <div v-if="selectedRouteType.id === 1" class="form-group row">
                <div class="col-sm-2">
                    <label>Route</label>

                    <v-select
                        v-model="selectedRouteFrom"
                        :options="optionsMap(routes, 1)"
                        label="name"
                        placeholder="Select route"
                        @input="updateRouteFrom">
                    </v-select>
                </div>

                <div class="col-sm-2">
                    <label>Pickup</label>

                    <input
                        v-if="isCustom"
                        v-model="selectedCustomRouteFrom"
                        type="text"
                        class="input custom"
                        placeholder="Select custom route"
                        @input="updateCustomRouteFrom">
                    </input>

                    <v-select
                        v-else
                        v-model="selectedFrom"
                        :options="routesPickup"
                        label="name"
                        placeholder="Select start"
                        @input="updateFrom">
                    </v-select>
                </div>

                <div class="col-sm-3">
                    <label>Date</label>
                    <datepicker input-class="bg-lightest" v-model="selectedDateFrom" format="yyyy-MM-dd" @input="updateDateFrom"></datepicker>
                </div>

                <div class="col-sm-2">
                    <label>Time</label>

                    <div v-if="isCustom">
                        <input type="time" class="input" v-model="selectedTimeFrom" @input="updateTimeFrom">
                    </div>
                    <div v-else>
                        <v-select
                            v-if="selectedFrom"
                            v-model="selectedTimeFrom"
                            :options="selectedFrom.schedules"
                            label="timeShort"
                            placeholder="Select time"
                            @input="updateTimeFrom">
                        </v-select>
                        <div v-else class="input"></div>
                    </div>
                </div>

                <div class="col-sm-3">
                    <label>To</label>
                    <div class="input">
                        <div v-if="selectedFrom">
                            {{ selectedFrom.iteneraries[selectedFrom.iteneraries.length - 1].stop.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="form-group row">
                <div class="col-sm-2">
                    <label>Route</label>

                    <v-select
                        v-model="selectedRouteTo"
                        :options="optionsMap(routes, 2)"
                        label="name"
                        placeholder="Select route"
                        @input="updateRouteTo">
                    </v-select>
                </div>

                <div class="col-sm-2">
                    <label>Drop off</label>

                    <input
                        v-if="isCustom"
                        v-model="selectedCustomRouteTo"
                        type="text"
                        class="input custom"
                        placeholder="Select custom route"
                        @input="updateCustomRouteTo">
                    </input>

                    <v-select
                        v-else
                        v-model="selectedTo"
                        :options="routesDropoff"
                        label="name"
                        placeholder="Select start"
                        @input="updateTo">
                    </v-select>
                </div>

                <div class="col-sm-3">
                    <label>Date</label>
                    <datepicker input-class="bg-lightest" v-model="selectedDateTo" format="yyyy-MM-dd" @input="updateDateTo"></datepicker>
                </div>

                <div class="col-sm-2">
                    <label>Time</label>

                    <div v-if="isCustom">
                        <input type="time" class="input" v-model="selectedTimeTo" @input="updateTimeTo">
                    </div>
                    <div v-else>
                        <v-select
                            v-if="selectedTo"
                            v-model="selectedTimeTo"
                            :options="selectedTo.schedules"
                            label="timeShort"
                            placeholder="Select time"
                            @input="updateTimeTo">
                        </v-select>
                        <div v-else class="input"></div>
                    </div>
                </div>

                <div class="col-sm-3">
                    <label>From</label>
                    <div class="input">
                        <div v-if="selectedTo">
                            {{ selectedTo.iteneraries[0].stop.name }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="form-group row">
                <div class="col-sm-2">
                    <label>Route</label>

                    <v-select
                        v-model="selectedRouteFrom"
                        :options="optionsMap(routes, 1)"
                        label="name"
                        placeholder="Select route"
                        @input="updateRouteFrom">
                    </v-select>
                </div>

                <div class="col-sm-2">
                    <label>Pickup</label>

                    <input
                        v-if="isCustom"
                        v-model="selectedCustomRouteFrom"
                        type="text"
                        class="input custom"
                        placeholder="Select custom route"
                        @input="updateCustomRouteFrom">
                    </input>

                    <v-select
                        v-else
                        v-model="selectedFrom"
                        :options="routesPickup"
                        label="name"
                        placeholder="Select pickup"
                        @input="updateFrom">
                    </v-select>
                </div>

                <div class="col-sm-3">
                    <label>Date</label>
                    <datepicker input-class="bg-lightest" v-model="selectedDateFrom" format="yyyy-MM-dd" @input="updateDateFrom"></datepicker>
                </div>

                <div class="col-sm-2">
                    <label>Time</label>

                    <div v-if="isCustom">
                        <input type="time" class="input" v-model="selectedTimeFrom" @input="updateTimeFrom">
                    </div>
                    <div v-else>
                        <v-select
                            v-if="selectedFrom"
                            v-model="selectedTimeFrom"
                            :options="selectedFrom.schedules"
                            label="timeShort"
                            placeholder="Select time"
                            @input="updateTimeFrom">
                        </v-select>
                        <div v-else class="input"></div>
                    </div>
                </div>

                <div class="col-sm-3">
                    <label>To</label>
                    <div class="input">
                        <div v-if="selectedFrom">
                            {{ selectedFrom.iteneraries[selectedFrom.iteneraries.length - 1].stop.name }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-sm-2">
                    <label>Route</label>

                    <v-select
                        v-model="selectedRouteTo"
                        :options="optionsMap(routes, 2)"
                        label="name"
                        placeholder="Select route"
                        @input="updateRouteTo">
                    </v-select>
                </div>

                <div class="col-sm-2">
                    <label>From</label>
                    <div class="input">
                        <div v-if="selectedTo">
                            {{ selectedTo.iteneraries[0].stop.name }}
                        </div>
                    </div>
                </div>

                <div class="col-sm-3">
                    <label>Drop off</label>

                    <input
                        v-if="isCustom"
                        v-model="selectedCustomRouteTo"
                        type="text"
                        class="input custom"
                        placeholder="Select custom route"
                        @input="updateCustomRouteTo">
                    </input>

                    <v-select
                        v-else
                        v-model="selectedTo"
                        :options="routesDropoff"
                        label="name"
                        placeholder="Select dropoff"
                        @input="updateTo">
                    </v-select>
                </div>

                <div class="col-sm-3">
                    <label>Date</label>
                    <datepicker input-class="bg-lightest" v-model="selectedDateTo" format="yyyy-MM-dd" @input="updateDateFrom"></datepicker>
                </div>

                <div class="col-sm-2">
                    <label>Time</label>

                    <div v-if="isCustom">
                        <input type="time" class="input" v-model="selectedTimeTo" @input="updateTimeTo">
                    </div>
                    <div v-else>
                        <v-select
                            v-if="selectedTo"
                            v-model="selectedTimeTo"
                            :options="selectedTo.schedules"
                            label="timeShort"
                            placeholder="Select time"
                            @input="updateTimeTo">
                        </v-select>
                        <div v-else class="input"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Timepicker from '@/tools/Timepicker'
    import Datepicker from 'vuejs-datepicker'

    export default {
        data: function() {
            return {
                form: {},
                selectedRouteType: null,
                selectedTimeFrom: null,
                selectedTimeTo: null,
                selectedFrom: null,
                selectedTo: null,
                selectedRouteFrom: null,
                selectedRouteTo: null,
                selectedCustomRouteFrom: null,
                selectedCustomRouteTo: null,
                selectedDateFrom: null,
                selectedDateTo: null,
                isCustom: false,
            }
        },
        created: function() {

            this.form = JSON.parse(JSON.stringify(this.getClonedReservation));

            this.selectedDateFrom = this.startDate;
            this.selectedDateTo = this.endDate;
        },
        asyncComputed: {
            async routeTypes() {
                try {
                    let response = await axios.get('/api/settings/GetTransportationDirectionTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        // Map FK information through selects

                        if (this.form.transport && this.form.transport.transfers !== undefined) {
                            const count = this.form.transport.transfers.length;

                            if (count > 0) {
                                // We're either editing a round trip configuration
                                // or a single trip configuration (one-way or return)

                                const type = (count > 1) ? 3 : this.form.transport.transfers[0].transportDirection;

                                this.form.routeType = type;
                                this.selectedRouteType = response.data.find(item => item.id === type);
                            }
                        }
                        else {
                            this.$set(this.form, 'transport', { transfers: [] });
                            this.selectedRouteType = response.data[0];
                            this.form.routeType = response.data[0].id;
                        }

                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error);
                }
            },

        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
                'account',
                'getAllRoutes'
            ]),
            routes: function () {
                let response = this.getAllRoutes
                let list = [];

                if (this.form.transport.transfers !== undefined) {
                    const count = this.form.transport.transfers.length;

                    // Route dropdown:
                    // First dropdown "from": stop
                    // Date:
                    // Time:
                    // Second dropdown "to": exitStop

                    if (count > 0) {
                        const routesPickup = this.routesMap(response.data, 1);
                        const routesDropoff = this.routesMap(response.data, 2);
                        const transferFrom = this.form.transport.transfers[0];
                        const direction = transferFrom.transportDirection;

                        this.selectedFrom = routesPickup.find(r => r.id === transferFrom.stop.id);
                        this.selectedTimeFrom = transferFrom.schedule.timeShort;
                        this.selectedDateFrom = transferFrom.date;
                        this.selectedRouteFrom = transferFrom.route;

                        // Round trip? Handle the "second journey".
                        // Otherwise we're done

                        if (count > 1) {
                            const transferTo = this.form.transport.transfers[0];

                            this.selectedTo = routesDropoff.find(r => r.id === transferTo.stop.id);
                            this.selectedTimeTo = transferTo.schedule.timeShort;
                            this.selectedDateTo = transferTo.date;
                            this.selectedRouteTo = transferTo.route;
                        }
                    }
                }

                return response.data;

            },
            routesPickup: function() {
                return this.routesMap(this.routes, 1);
            },
            routesDropoff: function() {
                return this.routesMap(this.routes, 2);
            },
            isSingleTrip: function() {
                return (this.selectedRouteType && this.selectedRouteType.id !== undefined && (this.selectedRouteType.id === 1 || this.selectedRouteType.id === 2))
            },
            startDate: function() {
                return this.formatDate(this.getClonedReservation.event.start);
            },
            endDate: function() {
                return this.formatDate(this.getClonedReservation.event.end);
            },
        },
        methods: {
            ...mapActions([
                'updateClonedReservation'
            ]),
            optionsMap: function(routes, type) {
                let all = routes.filter(r => r.type === type);
                let options = [];

                all.forEach(a => {
                    options.push({ id: a.id, name: a.name });
                });

                options.push({ id: 0, name: 'Custom' });

                return options;
            },
            routesMap: function(routes, type) {
                let filtered = routes.filter(r => r.type === type);
                let options = [];

                filtered.forEach(f => {
                    f.iteneraries.forEach(i => {
                        let found = options.find(o => o.id === i.stop.id);

                        if (!found) {
                            options.push({
                                type: type,
                                id: i.stop.id,
                                name: i.stop.name,
                                schedules: i.schedules,
                                iteneraries: f.iteneraries,
                            })
                        }
                    });
                });

                return options;
            },
            checkSelectedRoute: function(options) {
                // Select the correct route dropdown option if we are editing

                if (this.form.transport.transfers !== undefined) {
                    const count = this.form.transport.transfers.length;

                    if (count > 0) {
                        if (count > 1) {
                        }
                        else {
                            const transfer = this.form.transport.transfers[0];
                            const direction = transfer.transportDirection;
                            const id = (transfer.route !== undefined && transfer.route) ? transfer.route.id : null;

                            // One-way (1) or return (2)

                            if (direction === 1) {
                                this.selectedRouteFrom = options.find(r => r.id === id);
                            }
                            else {
                                this.selectedRouteTo = options.find(r => r.id === id);
                            }
                        }
                    }
                }
            },
            changeRouteType: function(routeType) {
                if (this.routeTypes) {
                    this.selectedRouteType = this.routeTypes.find(r => r.id === parseInt(routeType));
                    this.cleanList();
                }
            },
            updateFrom: function() {
                console.log('on updateFrom with selectedFrom = ', this.selectedFrom)
                if (this.selectedFrom) {
                    this.selectedTimeFrom = this.selectedFrom.schedules[0];

                    let from = this.form.transport.transfers.find(t => t.transportDirection === this.selectedFrom.type);
                    let exitStop = this.selectedFrom.iteneraries[this.selectedFrom.iteneraries.length - 1].stop;
                    let stop = {
                        id: this.selectedFrom.id,
                        description: this.selectedFrom.name
                    };
                    let data = {
                        order: 0,
                        date: moment(this.selectedDateFrom).format('YYYY-MM-DD HH:mm:ss'),
                        transportDirection: this.selectedFrom.type,
                        isCustom: false,
                        route: this.selectedRouteFrom,
                        stop: stop,
                        exitStop: exitStop,
                        schedule: this.selectedTimeFrom,
                    }

                    if (from) {
                        this.$set(this.form.transport.transfers, this.form.transport.transfers.indexOf(from), data);
                    }
                    else {
                        this.form.transport.transfers.push(data);
                    }

                    console.log('Changed from', this.form.transport);
                }
            },
            updateTo: function() {
                console.log('on updateTo with selectedTo = ', this.selectedTo)
                if (this.selectedTo) {
                    this.selectedTimeTo = this.selectedTo.schedules[0];

                    let to = this.form.transport.transfers.find(t => t.transportDirection === this.selectedTo.type);
                    let exitStop = {
                        id: this.selectedTo.id,
                        description: this.selectedTo.name
                    };
                    let stop = this.selectedTo.iteneraries[0].stop;
                    let data = {
                        order: 0,
                        date: moment(this.selectedDateTo).format('YYYY-MM-DD HH:mm:ss'),
                        isCustom: false,
                        route: this.selectedRouteTo,
                        transportDirection: this.selectedTo.type,
                        stop: stop,
                        exitStop: exitStop,
                        schedule: this.selectedTimeTo,
                    }

                    if (to) {
                        this.$set(this.form.transport.transfers, this.form.transport.transfers.indexOf(to), data);
                    }
                    else {
                        this.form.transport.transfers.push(data);
                    }

                    console.log('Changed to', this.form.transport);
                }
            },
            updateTimeFrom: function() {
                if (this.selectedFrom) {
                    let from = this.form.transport.transfers.find(t => t.transportDirection === this.selectedFrom.type);

                    if (from) {
                        from.schedule = this.selectedTimeFrom;
                        this.$set(from, 'date', moment(this.selectedDateFrom).format('YYYY-MM-DD HH:mm:ss'));
                    }
                }

                this.$emit('updateFields', this.form.transport);
            },
            updateTimeTo: function() {
                if (this.selectedTo) {
                    let to = this.form.transport.transfers.find(t => t.transportDirection === this.selectedTo.type);

                    if (to) {
                        to.schedule = this.selectedTimeTo;
                        this.$set(to, 'date', moment(this.selectedDateTo).format('YYYY-MM-DD HH:mm:ss'));
                    }
                }

                this.$emit('updateFields', this.form.transport);
            },
            updateDateFrom: function() {
                if (this.form.transport.transfers !== undefined && this.selectedFrom) {
                    let from = this.form.transport.transfers.find(t => t.transportDirection === this.selectedFrom.type);

                    if (from) {
                        this.$set(from, 'date', moment(this.selectedDateFrom).format('YYYY-MM-DD HH:mm:ss'));
                    }
                }

                this.$emit('updateFields', this.form.transport);
            },
            updateDateTo: function() {
                if (this.form.transport.transfers !== undefined && this.selectedTo) {
                    let to = this.form.transport.transfers.find(t => t.transportDirection === this.selectedTo.type);

                    if (to) {
                        this.$set(to, 'date', moment(this.selectedDateTo).format('YYYY-MM-DD HH:mm:ss'));
                    }
                }

                this.$emit('updateFields', this.form.transport);
            },
            updateRouteFrom: function() {
                this.isCustom = false;

                if (this.selectedRouteFrom) {
                    if (this.selectedRouteFrom.id == 0) {
                        this.updateCustomRouteFrom();
                        return;
                    }

                    let from = this.form.transport.transfers.find(t => t.transportDirection === 1);

                    if (from) {
                        this.isCustom = false;
                        from.isCustom = false;
                        from.route = this.selectedRouteFrom;
                        this.$emit('updateFields', this.form.transport);
                    }
                }
            },
            updateRouteTo: function() {
                console.log('on updateRouteTo')
                this.isCustom = false;

                if (this.selectedRouteTo) {
                    if (this.selectedRouteTo.id == 0) {
                        this.updateCustomRouteTo();
                        return;
                    }

                    let to = this.form.transport.transfers.find(t => t.transportDirection === 2);

                    if (to) {
                        this.isCustom = false;
                        to.isCustom = false;
                        to.route = this.selectedRouteTo;
                        this.$emit('updateFields', this.form.transport);
                    }
                }
            },
            updateCustomRouteFrom: function() {
                console.log('on updateCustomRouteFrom')
            },
            updateCustomRouteTo: function() {
                console.log('on updateCustomRouteTo')
            },
            cleanList: function() {
               // Clear array if not in type 3

                if (this.selectedRouteType.id !== 3) {
                    this.form.transport.transfers = [];
                    this.selectedFrom = null;
                    this.selectedTimeFrom = null;
                    this.selectedDateFrom = null;
                    this.selectedTo = null;
                    this.selectedTimeTo = null;
                    this.selectedDateTo = null;
                }
            }
        },
        components: {
            vSelect: extendedVSelect,
            Timepicker,
            Datepicker
        },
    }
</script>
<style lang="scss" scoped>
    .custom {
        width: 120px;
    }

    div.input,
    div.input > div {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        height: 39px;
    }

    .actions {
        > li {
            margin-left: 1rem;

            &:first-child {
                margin-left: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// TransportForm.vue?03a444d6